const getDataFromAPI = (lang) => {
  //const ENDPOINT = `https://tncdigital.cat/damcloudservicetnctest/rest/meta/allasset/lang/${lang}`;
  // console.log("el lang es::" + lang);
  //const ENDPOINT = `http://15.237.23.231:8020/damcloudtaservice/rest/meta/allasset/lang/${lang}`;
  //const ENDPOINT = `http://localhost:8080/damcloudtaservice/rest/meta/allasset/lang/${lang}`;
  const ENDPOINT = `https://tncdigital.cat/damcloudservicetnceducativo/rest/meta/allasset/lang/${lang}`;

  return fetch(ENDPOINT)
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data.map((asset) => {
        // console.log(asset);
        return {
          title: asset.title,
          subtitle: asset.subtitle,
          assetId: asset.assetId,
          autor: asset.autorship,
          beginDate: asset.beginDate,
          species: asset.species,
          catalogue: asset.catalogue,
          coverUrl: asset.coverUrl,
          posterUrl: asset.posterUrl,
          description: asset.description,
          duration: asset.duration,
          eventDetail: asset.eventDetail,
          gender: asset.gender,
          premium: asset.premium,
          recommendedAge: asset.recommendedAge,
          thirdPartyURLPlayer: asset.thirdPartyURLPlayer, //kubin?
          thirdPartyId: asset.thirdPartyId,
          trailer: asset.trailer,
          webPublicUrl: asset.webPublicUrl,
          valid: asset.valid, //¿?
          staff: asset.assetRolePersonList,
          poster_opac: 0.25,
          assetRolePersonList: asset.assetRolePersonList,
          subtitleList: asset.subtitleList,
          idiomList: asset.idiomList,
          textButtonPoster: asset.textButtonPoster,
          textButtonPosterActive: asset.textButtonPosterActive,
          relatedContentList:asset.relatedContentList,
          materialUrl:asset.materialUrl,
          showEvent:asset.showEvent,
          showButtonPlay:asset.showButtonPlay,
          seasonName:asset.seasonName
        };
      });
    });
};

export default getDataFromAPI;
